/**
 * 共通で使う処理などを定義
 */

import moment from 'moment'
import {helperIsComma, helperNoneComma} from '@/js/util/helper'

export default {
  methods: {
    /**
     * 金額にカンマをつける処理
     * @param {string} form key名
     */
    isComma(form) {
      this.form[form] === '' || this.form[form] == null
        ? (this.form[form] = null)
        : (this.form[form] = helperIsComma(this.form[form]))
    },
    /**
     * 金額にカンマを省く処理
     * @param {string} form key名
     */
    noneComma(form) {
      if (this.form[form]) this.form[form] = helperNoneComma(this.form[form])
    },
    // 遷移時に同じurlでもエラーにならない処理
    transitionSame(name, query = null) {
      if (this.$route.name !== name) {
        this.$router.push({name, query})
      }
    },
    // eventの強制発火
    ignitionEvent(type, id) {
      // setTimeout(() => {
      const events = type.split(',')
      events.map((item) => {
        const event = new Event(item)
        document.getElementById(id)
          ? document.getElementById(id).dispatchEvent(event)
          : document.getElementsByName(`${id}`).item(0)
          ? document.getElementsByName(`${id}`).item(0).dispatchEvent(event)
          : null
      })
      // },0)
    },
    // location.href遷移とともにキャッシュクリアする
    transitionClearCache(path) {
      location.href = `${path}?n=` + new Date().getTime()
    },
    /**
     * 値のコンバージョン
     * @param {array} conversions // コンバージョンをする配列
     * @param {boolean} flag // フロント用かDBようか判断 trueがフロント falseがDB
     * @param {object} form // fom値
     */
    valueConversion(conversions, flag, form) {
      conversions.map((conversion) => {
        switch (conversion.term) {
          case 'money': // カンマToggle
            form[conversion.key] = flag ? helperIsComma(form[conversion.key]) : helperNoneComma(form[conversion.key])
            break
          case 'number':
            form[conversion.key] = form[conversion.key]
              ? flag
                ? String(form[conversion.key])
                : Number(form[conversion.key])
              : form[conversion.key]
          default:
            break
        }
      })
      return form
    }
  },
  filters: {
    // 表示時にDateのフォーマットを指定
    dateFormat(val, format) {
      if (val && format) {
        return moment(val).format(format)
      }
      return ''
    },

    /**
     * 金額にコンマを追加
     * @param {string,number} val
     */
    isComma(val) {
      if (val != null || val !== '') {
        return helperIsComma(val)
      }
      return ''
    }
  }
}
